import { render, staticRenderFns } from "./group-box.vue?vue&type=template&id=e67191d2&scoped=true"
import script from "./group-box.vue?vue&type=script&lang=js"
export * from "./group-box.vue?vue&type=script&lang=js"
import style0 from "./group-box.vue?vue&type=style&index=0&id=e67191d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67191d2",
  null
  
)

export default component.exports